export const DEFAULT_CDN_URL = 'https://cdn8.classpass.com';
export const ASSET_BASE_URL = (__SERVER__ ? process.env.CLASSPASS_CDN_URI : window.resourceBaseUrl) ?? '';
export const DIST_URL = `${ASSET_BASE_URL}/dist/`;
